import { calculateAdjustedValue } from "./calculateAdjustedValue";
import { YAxisConfig } from "./common/types/ISerieConfigMap";

interface SensorSerie {
  yAxis?: number;
  [key: string]: any;
}

interface SensorProcessResult {
  serie: SensorSerie[];
  yAxis: YAxisConfig[];
}

/**
 * Combines sensor yAxis values with forecast yAxis values.
 *
 * Only adjusts forecast yAxis entries where the sensor actually has series
 * with an explicit yAxis index. Series without an explicit yAxis (e.g.
 * windbarb/direction) are ignored to prevent sparse-array placeholders
 * (from processSerie's hole-filling) from inflating the chart scale.
 */
export const combineSensorYAxis = (
  yAxisProcessed: YAxisConfig[] | null,
  sensorProcessResult: SensorProcessResult | null,
): void => {
  if (!yAxisProcessed?.length) return;
  if (!sensorProcessResult?.serie?.length) return;

  const sensorYAxisIndices = new Set(
    sensorProcessResult.serie
      .filter((s) => typeof s.yAxis === "number")
      .map((s) => s.yAxis!),
  );

  for (const yAxisIndex of sensorYAxisIndices) {
    const forecastYAxis = yAxisProcessed[yAxisIndex];
    const sensorYAxis = sensorProcessResult.yAxis?.[yAxisIndex];

    if (!forecastYAxis || !sensorYAxis) continue;

    const sensorYAxisMax = sensorYAxis.max;
    const sensorYAxisMin = sensorYAxis.min;

    if (sensorYAxisMax > forecastYAxis.max) {
      yAxisProcessed[yAxisIndex].max = calculateAdjustedValue(
        forecastYAxis.max,
        sensorYAxisMax,
      );
    }

    if (sensorYAxisMin < forecastYAxis.min) {
      yAxisProcessed[yAxisIndex].min = calculateAdjustedValue(
        forecastYAxis.min,
        sensorYAxisMin,
        false,
      );
    }
  }
};
